module.exports = __webpack_public_path__ + "static/media/View-1.60291241.webp";